// extracted by mini-css-extract-plugin
module.exports = {"spinner":"fJQTzzuC","spin":"MGePYEpL"};